<template>
  <div class="custom-ui-steppers-wrapper">
    <div
      class="stepper-item"
      v-for="(item, index) in items"
      :key="index"
      @click="showNumbers ? null : setActive(index)"
      :class="{
        'active-step': active === index,
        clickable: !showNumbers,
      }"
      :style="{ width: stepWidth }"
    >
      <div class="stepper-item-number" v-if="showNumbers">{{ index + 1 }}</div>
      <div class="stepper-item-title" :class="!showNumbers ? 'only-title' : ''">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IUISteppers } from '@/types/Components/UIKit'
  import { ref, watch } from 'vue'

  const {
    items = [],
    showNumbers = false,
    stepWidth = '80px',
    activeIndex = 0,
  } = defineProps<IUISteppers>()
  const emit = defineEmits(['select'])

  const active = ref<number>(activeIndex)

  const setActive = (index: number) => {
    active.value = index
    emit('select', index)
  }

  watch(
    () => activeIndex,
    newValue => {
      active.value = newValue
    },
  )
</script>

<style lang="scss" scoped>
  .custom-ui-steppers-wrapper {
    width: 100%;
    @include flexible($direction: row, $justify: space-evenly, $align: center, $wrap: wrap);
    .stepper-item {
      height: auto;
      @include flexible($direction: column, $justify: center, $align: center);
      color: $primary-text-color;

      @include media(xs, sm, md) {
        width: 50px;
      }
      .clickable {
        cursor: pointer;
      }
      &.active-step {
        .stepper-item-number {
          background: $brandColor;
          border: 1px solid $brandColor;
          color: $white;
        }
        .stepper-item-title {
          &.only-title {
            color: $brandColor;
            border-bottom: 2px solid $brandColor;
          }
        }
      }
      .stepper-item-number {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: $white;
        @include flexible($direction: row, $justify: center, $align: center);
        border: 1px solid $border-color;
        font-size: 1.25rem;
        @include media(xs, sm, md) {
          width: 35px;
          height: 35px;
          font-size: 1rem;
        }
      }
      .stepper-item-title {
        width: 100%;
        font-size: 0.8rem;
        margin-top: 5px;
        text-align: center;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-bottom: 5px;
        cursor: pointer;
      }
    }
  }
</style>

<!-- Numaralı stepler tıklanabilir olmamalı -->
